//include 16

jQuery(function(){

    var privateFunctions = {
        getDateFromTwoParts: function (from_date, from_time) {
            if (!from_date && !from_time)
                return null;
            var fromDate = moment(from_date).startOf("day");
            var fromTime = (!!from_time) ? moment(from_time).utc() : null;
            if (!!fromTime) {
                fromDate.hour(fromTime.hour());
                fromDate.minute(fromTime.minute());
                fromDate.second(fromTime.second());
            }
            return fromDate;
        },
        formatDate(momentDate, displayTime) {
            var content = momentDate.format("DD.MM.YYYY");
            if (!!displayTime) {
                content = momentDate.format("DD.MM.YYYY, HH:mm [Uhr]");
            }
            return content;
        }
    }

    $(".event-list").each(function () {
        var $this = $(this);
        var eventListData = $this.data("event-list");
        if (!eventListData)
            return;
        var eventsTable = $this.closest(".event-list-container").find(".event-list-table");
        eventsTable.html("");

        var closestDate = null;

        var toAppend = [];
        var indexOfClosest = -1;

        $.each(eventListData.events, function (index, value) {
            var from = privateFunctions.getDateFromTwoParts(value.from_date, value.from_time);
            var to = privateFunctions.getDateFromTwoParts(value.to_date, value.to_time);

            /*var content = privateFunctions.formatDate(from, !!value.from_time);
            if (value.SpansMultipleDays) {
                content += " - " + privateFunctions.formatDate(to, !!value.to_time);
            }*/

            // TPBB-944
            var content = "";
            if (value.SpansMultipleDays) {
                content = privateFunctions.formatDate(from, !!value.from_time);

                if(to && to.format("HH:mm") != "00:00"){
                    content += " - " + privateFunctions.formatDate(to, !!value.to_time);
                }
            }
            else {
                if(to && to.format("HH:mm") != "00:00"){
                    content =  privateFunctions.formatDate(from, !!value.from_time).replace("Uhr", "");
                    content += "- " + to.format("HH:mm [Uhr]");
                }
                else {
                    content =  privateFunctions.formatDate(from, !!value.from_time);
                }
            }

            var greyOut = false;
            if (moment().diff(to) > 0) {
                greyOut = true;
            }

            var row = $('<tr><td><span></span></td></tr>');
            row.find('span').text(content);
            if (greyOut)
                row.find('span').addClass("greyedOut");
            if (!greyOut) //only dates, that are in the future
                toAppend.push(row); //eventsTable.append(row);

            //**************we find the closest date*********************
            if (!closestDate) {
                closestDate = {
                    from: from,
                    useFromTime: !!value.from_time,
                    to: to,
                    useToTime: !!value.to_time,
                    SpansMultipleDays: value.SpansMultipleDays
                };
                indexOfClosest = toAppend.length - 1;
            } else if (moment().diff(from) >= 0 && moment().diff(to) <= 0) //from is in the past, to is in the future
            {
                closestDate = {
                    from: from,
                    useFromTime: !!value.from_time,
                    to: to,
                    useToTime: !!value.to_time,
                    SpansMultipleDays: value.SpansMultipleDays
                };
                indexOfClosest = toAppend.length - 1;
            } else if (moment().diff(from) <= 0 && Math.abs(moment().diff(closestDate.from)) > Math.abs(moment().diff(from))) {
                closestDate = {
                    from: from,
                    useFromTime: !!value.from_time,
                    to: to,
                    useToTime: !!value.to_time,
                    SpansMultipleDays: value.SpansMultipleDays
                };
                indexOfClosest = toAppend.length - 1;
            }
            //***********************************************************
        });

        $.each(toAppend, function (index, row) {
            if (indexOfClosest != index) {
                eventsTable.append(row);
            }
        });

        /*
        if(!!closestDate){
            $this.html("");
            var content = privateFunctions.formatDate(closestDate.from,closestDate.useFromTime);
            if(closestDate.SpansMultipleDays)
                content += " - "+privateFunctions.formatDate(closestDate.to,closestDate.useToTime);
            var greyOut = false;
            if(moment().diff(closestDate.to) > 0){
                greyOut = true;
            }
            var span = $('<span></span>');
            span.text(content);
            if(greyOut)
                span.addClass("greyedOut");
            $this.append(span);
        }
        */
    });

});